import moment from 'moment';

export function stringToArray ( propertyValue ) {

    const updatedpropertyValue = propertyValue.replace( /\n/g, ',' ),
        convertedArray = updatedpropertyValue.split( ',' );


    convertedArray.forEach( ( element, index ) => {

        convertedArray[index] = element.trim();

    } );

    return convertedArray;

}

export function convertUnixtodate ( givenDate ) {

    if ( givenDate && givenDate !== '' && givenDate !== 0 ) {

        return moment( givenDate * 1000 ).utc().format( 'MM/DD/YYYY' );

    }
    return '';

}

export function dateFromUTCToLocal ( givenDate ) {

    if ( !givenDate ) return givenDate;

    const date = moment( givenDate );
    if ( date && date.utcOffset() ) {

        date.subtract( date.utcOffset(), 'minutes' ).utc();

    } else {

        return givenDate;

    }
    return date.toDate();

}

export function dateFromLocalToUTC ( givenDate ) {

    if ( !givenDate ) return givenDate;

    const date = moment( givenDate );
    if ( date && date.utcOffset() ) {

        date.add( date.utcOffset(), 'minutes' ).utc();

    } else {

        return givenDate;

    }
    return date.toDate();

}

export function getFieldValue ( val ) {

    if ( val !== undefined && val !== '' && typeof ( val ) === 'string' ) {

        const splitVal = val.split( ' - ' );
        if ( splitVal.length > 1 ) {

            if ( ( splitVal[0] === undefined || splitVal[0] === 'undefined' )
             && ( splitVal[1] === undefined || splitVal[1] === 'undefined' ) ) return '';
            if ( ( splitVal[0] === undefined || splitVal[0] === '' )
             && splitVal[1] !== undefined ) return splitVal[1];
            if ( splitVal[0] !== undefined &&
                ( splitVal[1] === undefined || splitVal[1] === '' ) ) return splitVal[0];
            return val;

        }

        return val;

    }

    return val === undefined ? '' : val;


}
